import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGenericProducts } from "./genericProducts.service";
import {
  GenericProductsRequest,
  GenericProductsResponse,
} from "./genericProducts.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getGenericProducts = createAsyncThunk<
  GenericProductsResponse,
  GenericProductsRequest,
  { rejectValue: string }
>("genericProducts/getGenericProducts", async (params, { rejectWithValue }) => {
  try {
    return await fetchGenericProducts(params);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const loadMoreGenericProducts = createAsyncThunk<
  GenericProductsResponse,
  GenericProductsRequest,
  { rejectValue: string }
>(
  "genericProducts/loadMoreGenericProducts",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchGenericProducts(params);
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
);
